import { useTranslation } from 'react-i18next';
import { usePublicRoutes } from '../../Router/router.link';
import { all_routes as routes } from '../../Router/all_routes';

const sections = [
  ['overview', [['dashboard', 'layout-dashboard', 'salesdashboard']]],
  ['sales', [['ui.checkout', 'shopping-cart', 'pos'], ['invoices', 'file-invoice', 'invoice'], ['expenses', 'receipt', 'expenselist']]],
  ['customers', [['customers', 'users', 'customers'], ['appointments', 'calendar-event', 'appointments'], ['promo codes', 'ticket', 'promocodes'], ['gift vouchers', 'gift', 'giftvouchers']]],
  ['catalogue', [['products', 'layout-grid', 'productlist'], ['categories', 'category', 'categorylist'], ['manage stock', 'packages', 'managestock'], ['stock transfer', 'truck-delivery', 'stocktransfer']]],
  ['team', [['employees', 'users-group', 'employeegrid'], ['function', 'id-badge', 'designation'], ['leaves', 'calendar', 'leavesemployee'], ['payroll', 'wallet', 'payrollList']]],
  ['communication', [['sms dashboard', 'message', 'smsdashboard'], ['sms templates', 'template', 'smstemplates'], ['sms manual send', 'send', 'smssend'], ['sms logs', 'history', 'smslogs'], ['whatsapp inbox', 'brand-whatsapp', 'whatsappinbox']]],
  ['reports', [['sales report', 'chart-bar', 'salesreport'], ['best seller', 'trending-up', 'bestseller'], ['expense report', 'report-money', 'expensereport'], ['employee events report', 'calendar-stats', 'employeeeventreport'], ['employee prestation report', 'report', 'employeeservicereport'], ['customers report', 'users', 'customerreport']]],
  ['settings', [['student.settings', 'discount-2', 'discountsettings'], ['users', 'shield', 'users'], ['profile', 'user-circle', 'profile'], ['printer', 'printer', 'printersettings'], ['user manual', 'book', 'usermanual']]],
];

export function buildNavigation(allowedPaths, t) {
  const allowed = new Set(allowedPaths);
  return sections.map(([id, entries]) => ({
    id, label: t(`ui.nav.${id}`),
    submenuItems: entries.filter(([, , key]) => allowed.has(routes[key])).map(([label, icon, key]) => ({
      label: t(label), icon, link: routes[key],
    })),
  })).filter(section => section.submenuItems.length);
}

export default function useSidebarData() {
  const { t } = useTranslation();
  const { publicRoutes, posRoutes } = usePublicRoutes();
  return buildNavigation([...publicRoutes, ...posRoutes].map(route => route.path), t);
}
